import { SessionProvider } from "next-auth/react";
import dynamic from 'next/dynamic';
import '../styles/global.css';
import BuildInfo from '../components/global/build_info';
import { SocketProvider } from '../components/global/socket';
import WebPushContextProvider from '../components/global/webpush';
import { FocusStyleManager } from '@blueprintjs/core';
import { PageFocusProvider } from '../components/global/pagefocus';
import { SoundManagerProvider } from '../components/global/sound/soundmanager';
import DialogManager from '../components/global/dialog';
import { ActiveGamesProvider } from '../components/global/activegamesprovider';
import NavigationRegular from '../components/navbar/navigationregular';
import SpqrHead from '../components/global/spqrhead';
import PresenceProvider from '../components/global/presence';
import { ServerFlagsProvider } from '../components/global/serverflags';
import BlueprintPopupHack from '../components/global/blueprintpopuphack';
import { Notifications } from "../components/global/notifications/notifications";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import I18nStringsEnglish from "../src/models/i18n/english";
import DialogHost from "@/components/global/dialoghost";
import WrapupContextProvider from "@/components/seasonal/wrapup/wrapupcontext";

const ThemeProvider = dynamic(
    () => import('../components/global/theme'),
    { ssr: false },
);

const ToasterProvider = dynamic(
    () => import('../components/global/toaster'),
    { ssr: false },
);

i18next
    .use(initReactI18next)
    .init(
        {
            lng: 'en',
            debug: false,
            resources: {
                en: {
                    translation: I18nStringsEnglish,
                },
            },
        },
    );

export default function App(
    {
        Component,
        pageProps: { session, fromServer, ...pageProps }
    },
) {
    FocusStyleManager.onlyShowFocusOnTabs();

    return (
        <SessionProvider session={session}>
            <ThemeProvider>
                <ToasterProvider>
                    <SocketProvider>
                        <ServerFlagsProvider>
                            <PageFocusProvider>
                                <Notifications>
                                    <ActiveGamesProvider fromServer={fromServer}>
                                        <SoundManagerProvider>
                                            <PresenceProvider>
                                                <DialogManager>
                                                    <WrapupContextProvider>
                                                        <DialogHost />
                                                        <WebPushContextProvider>
                                                            <SpqrHead />
                                                            <NavigationRegular />
                                                            <div id="main">
                                                                <Component {...pageProps} />
                                                            </div>
                                                            <BuildInfo />
                                                            <BlueprintPopupHack />
                                                        </WebPushContextProvider>
                                                    </WrapupContextProvider>
                                                </DialogManager>
                                            </PresenceProvider>
                                        </SoundManagerProvider>
                                    </ActiveGamesProvider>
                                </Notifications>
                            </PageFocusProvider>
                        </ServerFlagsProvider>
                    </SocketProvider>
                </ToasterProvider>
            </ThemeProvider>
        </SessionProvider>
    );
}
